import React from 'react';
import { components } from 'react-select';

export const SelectContainer = ({
    innerProps,
    selectProps,
    ...props
}) => (
    <components.SelectContainer
        {...props}
        selectProps={selectProps}
        innerProps={{
            ...innerProps,
            'data-testid': selectProps?.testIds?.SelectContainer,
        }}
    />
);
